import { Cell, Grid } from 'baseui/layout-grid'
import { FormControl } from 'baseui/form-control'
import { KIND, SIZE } from 'baseui/button'
import { ModalHeader, ModalBody, ModalButton, Modal, ROLE } from 'baseui/modal'
import { StyledTable } from 'baseui/table'
import { Textarea } from 'baseui/textarea'
import useComments from './useComments'
import CommentRow from './CommentRow'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import IconCarbonCloudLogging from '@/shared/icons/IconCarbonCloudLogging'

const Comments = () => {
  const { t, css, isLoading, error, saveCommentHandler, setComment, comment, isOpen, setIsOpen, comments } =
    useComments()

  return (
    <>
      <SDButton
        kind={KIND.secondary}
        size={SIZE.compact}
        block={true}
        startEnhancer={() => <IconCarbonCloudLogging size={24} />}
        onClick={e => {
          e.preventDefault()
          setIsOpen(true)
        }}
      >
        {t('subscriptionTable:view_add_comments')}
      </SDButton>
      <Modal onClose={() => setIsOpen(false)} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <ModalHeader>{t('subscriptionTable:comments')}</ModalHeader>
        <ModalBody>
          <Grid>
            <Cell span={12}>
              <div className={css({ height: '250px' })}>
                <StyledTable role='grid'>
                  <CommentRow comments={comments} />
                </StyledTable>
              </div>
            </Cell>
            <Cell span={12}>
              <FormControl label={t('subscriptionTable:add_comment')} error={error}>
                <Textarea
                  value={comment}
                  onChange={e => setComment(e.target.value)}
                  size={SIZE.mini}
                  placeholder={t('subscriptionTable:write_comment')}
                  clearable
                />
              </FormControl>
              <FormControl>
                <ModalButton
                  className={css({ width: '100%' })}
                  isLoading={isLoading}
                  onClick={saveCommentHandler}
                  size={SIZE.mini}
                >
                  {t('subscriptionTable:validate_comment')}
                </ModalButton>
              </FormControl>
            </Cell>
          </Grid>
        </ModalBody>
      </Modal>
    </>
  )
}

export default Comments
